export const UpArrow = ({ strokeWidth="1.16667", stroke = 'white', width = "24", height="18", onClick, className}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="M17.8359 11.9163L12.0026 6.08301L6.16927 11.9163"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
